import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { UserService } from '../../../../services/core.user.service';

@Injectable()
export class ChangeEmailHelper {

  constructor(
    private translateService: GfTranslateService,
    private userService: UserService
  ) {}

  private validateEmail(email: string): boolean {
    return email && email.trim().length > 0;
  }

  private validateEmailsMatch(email: string, emailConfirm: string): boolean {
    return email === emailConfirm;
  }

  public postRequest(email: string, emailConfirm: string, unixName: string, captcha: string): Promise<any> {
    if (!this.validateEmail(email)) {
      return Promise.reject(this.translateService.translate('Email is missing or invalid.'));
    }

    if (!this.validateEmail(emailConfirm)) {
      return Promise.reject(this.translateService.translate('Email confirmation is missing or invalid.'));
    }

    if (!this.validateEmailsMatch(email, emailConfirm)) {
      return Promise.reject(this.translateService.translate('Email confirmation must match with email.'));
    }

    return this.userService.submitEmail(email, unixName, captcha);
  }
}
